import { useCanAccess } from '../auth/useCanAccess';
import { ACCOUNTING_SUITE_APP_ID } from '../apps/appsRegistry';

export type AccountingSecurableResource =
    | 'glChartAccounts'
    | 'glAccountGroups'
    | 'glVoucherTypes'
    | 'glJournalVouchers'
    | 'genBankInformation'
    | 'genCashInformation'
    | 'vendors'
    | 'trialBalance'
    | 'generalLedger'
    | 'partiesLedger'
    | 'taxLedger'
    | 'profitLoss'
    | 'customers'
    | 'bankPayments'
    | 'cashPayments'
    | 'bankReceipts'
    | 'cashReceipts'
    | 'vendorBills'
    | 'customerInvoices';

/** Flat strings e.g. accounting.glChartAccounts.read, accounting.glVoucherTypes.create */
export function useAccountingAccess(
    resource: AccountingSecurableResource,
    level: 'read' | 'write' | 'create' | 'delete'
): boolean {
    const action =
        level === 'read'
            ? 'read'
            : level === 'write'
              ? 'write'
              : level === 'create'
                ? 'create'
                : 'delete';
    return useCanAccess(ACCOUNTING_SUITE_APP_ID, resource, action);
}
